const breadcrumb = {
    Breadcrumb: {
        baseStyle: {
            container: {
                display: {base: 'none', md: 'flex'},
                py: 'spacing.6',
            },
            link: {
                color: 'color.text.breadcrumb.inactive',
                textDecoration: 'underline',
                fontWeight: '500',
                textStyle: 'paragraphSm',
                letterSpacing: '1px',
                _hover: {
                    textDecoration: 'underline',
                },
                // Chakra ui sets aria-current="page" on the active breadcrumb item, so we style it.
                '&[aria-current="page"]': {
                    color: 'color.text.breadcrumb.active',
                    textDecoration: 'none',
                    _hover: {
                        textDecoration: 'none',
                    },
                },
            },
            item: {},
            separator: {
                color: 'color.text.breadcrumb.inactive',
                mx: 'spacing.2',
            },
        },
        variants: {
            pdp: {
                container: {
                    // Hidden on mobile and tablet (Figma tablet PDP node 60805-38152 has no breadcrumb);
                    // shown only from lg (desktop) up.
                    display: {base: 'none', lg: 'flex'},
                    py: 'spacing.4',
                },
                link: {
                    textDecoration: 'none',
                    fontWeight: '350',
                    textStyle: 'paragraphXs',
                    _hover: {
                        textDecoration: 'none',
                    },
                    '&[aria-current="page"]': {
                        textDecoration: 'none',
                        _hover: {
                            textDecoration: 'none',
                        },
                    },
                },
                separator: {
                    color: 'color.text.breadcrumb.inactive',
                    mx: '0',
                },
            },
        },
    },
}

export default breadcrumb
